<div class="w-100 float-left">
    <div class="w-100 float-left v-align relative b-b">
        <h5 class="medium float-left"> {{'employees' | translate}} </h5>
        <div style="flex-grow: 1;"></div>
        <button class="btn float-left mb-2" (click)="goBack()"><i class="fa fa-arrow-left mr-sm-2"></i>{{'back' |
            translate}}
        </button>
        <!--  <button class="btn btn-primary float-right mb-2 ml-4" *ngIf="allSelectedEmplUserIds.length != 0" [disabled]="disabledButton" (click)="deleteEmployee()"> Delete </button>
        -->
    </div>

    <employeeFilter [displayTab]="'empgroup'" (searchEmp)="showSearchFilter($event)"></employeeFilter>

    <!-- EMPLOYEE DETAILS GRID -->
    <div class="w-100 float-left mt-3">
        <div class="light-bg w-100 float-left p-2 grid-details">
            <!-- <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                <div class="checkbox checkbox-primary">
                    <input id="self" type="checkbox" [(ngModel)]="selectedAll" (change)="selectAll($event)">
                    <label for="self" class="mb-0"></label>
                </div>
            </div> -->
            <div class="col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-lg-0 medium"> {{'code' | translate}} </h6>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-lg-0 medium"> {{'name' | translate}} </h6>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-lg-0 medium"> {{'email' | translate}} </h6>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-lg-0 medium"> {{'userName' | translate}} </h6>
            </div>
        </div>
        <ng-container *ngIf="employeeData.length != 0">
            <div class="w-100 float-left p-md-2 grid-details" *ngFor="let employee of employeeData;index as i">
                <!-- <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                    <div class="checkbox checkbox-primary">
                        <input id="id_{{employee.userId}}" type="checkbox" [(ngModel)]="employee.selected" (change)="checkIfAllSelected(employee,$event)">
                        <label for="id_{{employee.userId}}" class="mb-0"></label>
                    </div>
                </div> -->
                <div class="col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{employee.employeeCode}} </h6>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{employee.employeeName}} </h6>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{employee.email}} </h6>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{employee.userName}} </h6>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="employeeData.length == 0">
            <div class="w-100 float-left min-h2 relative" *ngIf="showLoading">
                <!-- <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center">

                    <img src="./assets/img/load.gif" alt="loading" width="80px">

            </div> -->
                <div class="loader-div">
                    <!-- <img src="assets/images/loader.gif" [ngStyle]="{'width':'100px'}" alt="loading"> -->
                    <div class="loader-gif"></div>
                </div>
            </div>
            <div class="w-100 float-left p-4 grid-details" *ngIf="!showLoading">
                <p class="text-center m-0 w-100 medium">{{'noResultFound' | translate}}</p>
            </div>
        </ng-container>

    </div>
    <!-- PAGINATION -->
    <div class="w-100 float-left my-4 light-bg p-3 align-v-center" (click)="clicked()" *ngIf="employeeData.length> 0">
        <h6 class="float-left mb-0"> {{((page-1)*pageSize)+1}} - {{pageSize*(page-1)+employeePageData.numberOfElements}}
            {{'itemsOf' | translate}} {{employeePageData.totalElements}}</h6>
        <div class="float-left ml-2 align-v-center">
            <label class="m-0 float-left">{{'showItemsPerPage' | translate}}</label>
            <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="pageSize"
                    (change)="OnPageSizeChanged($event.target.value)">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
            </select>
        </div>
        <div style="flex-grow: 1;"></div>
        <ngb-pagination [collectionSize]="collectionSize" [rotate]="true" [maxSize]="5" [pageSize]="pageSize"
                        [ellipses]="false"
                        [(page)]="page" [boundaryLinks]="true" (pageChange)="onPageChange($event)"
                        class="float-right"></ngb-pagination>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/tools/userGroup/employeesInGroup.html